import React from "react";

const Label = ({ label, required }) => {
  return (
    <label className="block text-gray-500 font-medium text-sm sm:text-base leading-none mb-2 sm:mb-3">
      {label}{" "}
      {required ? (
        <span
          className="text-red-500 text-base sm:text-lg"
        >
          *
        </span>
      ) : (
        ""
      )}
    </label>
  );
};

export default Label;
